// extracted by mini-css-extract-plugin
export default {"automationFooter":"AutomationFooter_automationFooter__CNxak"};